
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import { DriveSubjectContainerModel } from "../../../../../../models/aggregates/fm/link";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({providedIn: 'root'})
export class DriveSubjectService extends BaseApiTemplateService<DriveSubjectContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FM_MODULE + 'drive-subject-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FM_MODULE + 'drive-subject-links';
    this.httpClient = http;
  }
}
